// Legacy
import './legacy_jquery'

let batch_select_ready;

batch_select_ready = function() {
  let $checked, sendBatchAction, setChecked, setPartialyChecked, setUnchecked;
  $checked = false;
  $('#records_check_all').on('click', function(event) {
    let cbxs;
    cbxs = $('#records_list').find('input[type="checkbox"]');
    cbxs.prop('checked', $checked = !$checked);
    if ($checked) {
      setChecked();
    } else {
      setUnchecked();
    }
  });
  setChecked = function() {
    $('#records_check_all').find('i').removeClass('fa-square').removeClass('fa-minus-square').addClass('fa-check-square');
    $checked = true;
  };
  setUnchecked = function() {
    $('#records_check_all').find('i').removeClass('fa-check-square').removeClass('fa-minus-square').addClass('fa-square');
    $checked = false;
  };
  setPartialyChecked = function() {
    $('#records_check_all').find('i').removeClass('fa-check-square').removeClass('fa-square').addClass('fa-minus-square');
    $checked = false;
  };
  $('.records_check_all').on('click', function(event) {
    let cbxs;
    event.preventDefault();
    cbxs = $('#records_list').find('input[type="checkbox"]');
    cbxs.prop('checked', true);
    setChecked();
  });
  $('.records_check_none').on('click', function(event) {
    let cbxs;
    event.preventDefault();
    cbxs = $('#records_list').find('input[type="checkbox"]');
    cbxs.prop('checked', false);
    setUnchecked();
  });
  sendBatchAction = function() {
    return $.ajax({
      type: 'POST',
      url: $(this).data('url'),
      beforeSend: function(xhr) {
        return xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
      },
      data: {
        ids: $('input.records-check[type="checkbox"]:checked').map(function() {
          return $(this).data('id');
        }).get()
      },
      success: function(data) {
        if (data && data.hasOwnProperty('url')) {
          return window.location.href = data.url;
        } else {
          return window.location.reload();
        }
      }
    });
  };
  return $('.records_batch_action').on('click', function(event) {
    event.preventDefault();
    if ($(this).data('action-confirm')) {
      if (window.confirm($(this).data('action-confirm'))) {
        return sendBatchAction.call(this);
      }
    } else {
      return sendBatchAction.call(this);
    }
  });
};

$(document).ready(batch_select_ready);

$(document).on('turbo:load', batch_select_ready);
